import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Clock, FileDown } from "lucide-react";
import { api, downloadFile } from "@/lib/api";

export default function SignedAgreementCard({ code }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/franchise/agreement/signature").then((r) => setS(r.data)).catch(() => setS({ status: "pending_signature" })); }, []);
  if (!s) return null;
  const ok = s.status === "signed_verified";
  return (
    <Card className={`p-4 flex flex-wrap items-center justify-between gap-3 ${ok ? "border-emerald-200 bg-emerald-50/60" : "border-amber-200 bg-amber-50/60"}`} data-testid="fd-signed-agreement-card">
      <div className="flex items-start gap-3">
        {ok ? <ShieldCheck className="text-emerald-600 mt-0.5" size={20}/> : <Clock className="text-amber-600 mt-0.5" size={20}/>}
        <div>
          <div className="font-bold text-slate-900" data-testid="fd-signature-status">{ok ? "Digitally Signed – Verified" : "Awaiting Director's digital signature"}</div>
          <div className="text-xs text-slate-600 mt-0.5">
            {ok ? `Version ${s.version} · signed by ${s.signer} (${s.issuer}) · verified ${new Date(s.verified_at).toLocaleString("en-IN")}` : "You'll get an SMS and this download will appear once Karmivo's Director signs your agreement."}
          </div>
        </div>
      </div>
      {ok && (
        <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" data-testid="fd-download-signed-agreement"
          onClick={() => downloadFile("/franchise/agreement/signed.pdf", `Karmivo_Agreement_${code}_SIGNED.pdf`).catch(() => toast.error("Download failed"))}>
          <FileDown size={14} className="mr-1"/>Download signed agreement
        </Button>
      )}
    </Card>
  );
}
